// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import router from './router'
import App from './App.vue'
import Vuelidate from 'vuelidate';
import Axios from 'axios';
// import store from './store';
import Loading from 'vue-loading-overlay';
// import VueToastr from '@deveodk/vue-toastr';
// import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css'

import VueToastr2 from 'vue-toastr-2'
import 'vue-toastr-2/dist/vue-toastr-2.min.css'

import 'vue-loading-overlay/dist/vue-loading.css';
import 'fullcalendar/dist/fullcalendar.css';
import 'vue-datetime/dist/vue-datetime.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'


// import '@/assets/css/gallery.css'
// import '@/assets/styles/green/en.css'
// import '@/assets/css/flexslider.css'
  
  
    


import store from '@/store/index.js';
import FullCalendar from 'vue-full-calendar';
import CKEditor from '@ckeditor/ckeditor5-vue';
import { Datetime } from 'vue-datetime';

import VueI18n from 'vue-i18n';
import LanguageFile from '@/_messages';
import VueSwal from 'vue-swal';
import Multiselect from 'vue-multiselect';
import VueCookies from 'vue-cookies'

Vue.component('full-calendar',FullCalendar);

window.toastr = require('toastr')
 
Vue.use(VueToastr2);
Vue.config.productionTip = false;
Vue.use( CKEditor );
Vue.use(FullCalendar);
Vue.use(Axios);
Vue.use(Vuelidate)
Vue.use(BootstrapVue)
Vue.use(Datetime)
Vue.use(VueI18n)
Vue.use(VueSwal)
Vue.use(Multiselect)
Vue.use(VueCookies)



let messages = LanguageFile.messages;
const i18n = new VueI18n({
  locale: 'en', 
  fallbackLocale: 'en',
  messages 
})

// Vue.use(VueToastr, {
//     defaultPosition: 'toast-top-right',
// });
Vue.use(Loading, {
 width: 64,
 height: 64,
 isFullPage : true,
 canCancel: false,
});


Vue.component("loading", Loading);


router.beforeEach((to, from, next) => {
  console.log(to);
  if ( localStorage.getItem('loggedin') || to.name == 'Login' || 
      to.name == 'SharedMenu' || to.name == 'Register'|| to.name == 'LoginAsAdmin' || to.name == 'LoginFromToken' || to.name == 'ClientWeeklyShare' ) {
    console.log(localStorage.getItem('loggedin') || to.name == 'Login');

    next()
  } else {
    console.log(localStorage.getItem('loggedin') || to.name == 'Login');
    next({
      name: "Login",
    });
  }
});

/* eslint-disable no-new */
new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')


